import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FormFooter } from '../../../elements/form-footer';
import { FieldError } from '../../../elements/field-error/field-error';
import { TextArea } from '../../../elements/text-area';
import { Toggle } from '../../../elements/toggle';
import { SelectAsync } from '../../../elements/select-async';


// construccion del objeto yup de validacion del cuestionario
let obligado = {
    IMEI: Yup.string().required('obligatorio'),
    phone_number: Yup.string().required('obligatorio'),
    //vehicle: Yup.mixed().required('obligatorio')
};
const validacion = Yup.object().shape(obligado);

const initialValues: any = {
    IMEI: '',
    phone_number: ''
};

export const DevicesForm = ({
    item,
    close,
    doDelete
}: {
    item?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };

    const { api, state, options } = useHttpClient();
    const [data, setData] = useState<any | null>(null);


    // Load initial data
    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        const after = { ...values };

        console.log('after', after)

        

        if(after.vehicle == null) {
            after.vehicle = null;
        }else{
            after.vehicle = after.vehicle?.id
        }

        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);

        if (enviaremos.id) {
            // update

            api(`/fleet/tracker-devices/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            // create

            api('/fleet/tracker-devices/', 'POST', enviaremos);
        }
    };

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('tracker-devices')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    close();
                }
            }
        }

        if (state.error) {
            if (state.error.name) {
                toast.error(state.error.name[0]);
            } else {
                console.log('state.error.vehicle[0]', state.error.vehicle[0] == "Ya existe Tracker Device con este vehicle.")
                if(state.error.vehicle[0] == "Ya existe Tracker Device con este vehicle.") {
                    toast.error(`${t('common.error.tracker-device')}`);
                }
                
            }
        }
    }, [state]);

    return (
        <Formik
            initialValues={data || initialValues}
            onSubmit={onSubmit}
            validationSchema={validacion}
            enableReinitialize
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">


                    <Input
                        label={t('IMEI')}
                        type="text"
                        placeholder={t('IMEI')}
                        name="IMEI"
                        value={values.IMEI}
                        onChange={(value) =>
                            setFieldValue('IMEI', value.IMEI)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'IMEI'}
                    />
                    <Input
                        label={t('common.form-label.phone')}
                        type="text"
                        placeholder={t('common.form-label.phone')}
                        name="phone_number"
                        value={values.phone_number}
                        onChange={(value) =>
                            setFieldValue('phone_number', value.phone_number)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'phone_number'}
                    />


                    <SelectAsync
                        name="vehicle"
                        label={t('common.label.vehiculo')}
                        placeholder={t('common.button.search')}
                        items={async (value: string) => {
                            return await options(
                                `/fleet/vehicles/?plate=${value}`
                            );
                        }}
                        value={values.vehicle}
                        optionsLabel={"plate"}
                        onChange={(value: any) => {
                            setFieldValue('vehicle', value || null);
                        }}
                    />
                    <FieldError touched={touched} errors={errors} field={"vehicle"} />




                    <FormFooter
                        item={item}
                        doDelete={doDelete}
                        doSubmit={handleSubmit}
                        close={close}
                    />
                </form>
            )}
        </Formik>
    );
};